import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetEconomicSheets from "services/recordSheets/useGetEconomicSheets";
import EntornoLaboral from "../Comun/EntornoLaboral";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, formatText, formatDate, formatCurrency, formatBoolean, buildEntornoLaboralProps } from "../SheetLayout";

const GastosTransporte: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const gastoTransporteId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { getTransportationExpense, dataEconomicSheet: d, loadingEconomicSheet, errorEconomicSheet } = useGetEconomicSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getTransportationExpense(userId, prestacionId, gastoTransporteId); }, []);

  if (loadingEconomicSheet) return <section className="container"><LoaderMin /></section>;
  if (errorEconomicSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title="Gastos Transporte"
        icon="truck"
        pills={<>
          <SheetPill label="Tipo" value={formatText(d.tiposTransporte)} />
          <SheetPill label="Pagado" value={formatBoolean(d.estaPagado)} />
        </>}
      />

      <SheetSection title="Detalle" icon="file-text">
        <SheetGrid>
          <SheetField label="Tipo de Transporte"  value={formatText(d.tiposTransporte)} wide />
          <SheetField label="Cantidad"            value={formatText(d.cantidad)} />
          <SheetField label="Médico"              value={formatText(d.medico)} wide />
          <SheetField label="Fecha Inicio"        value={formatDate(d.fechaInicio)} />
          <SheetField label="Fecha Fin"           value={formatDate(d.fechaFin)} />
          <SheetField label="Importe"             value={formatCurrency(d.importe)} />
          <SheetField label="Pagado"              value={formatBoolean(d.estaPagado)} />
          <SheetField label="Excluido"            value={formatBoolean(d.estaExcluido)} />
        </SheetGrid>
      </SheetSection>

      {d.entornoLaboral && <EntornoLaboral {...buildEntornoLaboralProps(d)} />}
    </SheetPage>
  );
};

export default GastosTransporte;
